import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Spinner, Table, Pagination } from 'react-bootstrap';
import NavbarComponent from '../layout/NavbarComponent';
import Footer from '../layout/Footer';
import { Layout } from '../layout/Layout';
import PaginationComponent from './PaginationComponent';
const API_URL = process.env.REACT_APP_API_URL;

const UsersDetails = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${API_URL}/checkingUser?page=${page}&size=${size}`
            );

            const data = response.data;
            setUsers(data.content);
            setTotalPages(data.totalPages);
        } catch (error) {
            console.error("Error loading users:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [page, size]);



    return (
        <Layout>
            <div className="users-page">

                {loading ? (
                    <div className="users-loading">
                        <Spinner animation="border" style={{ color: "#e07b39" }} />
                    </div>
                ) : (
                    <div className="users-container">

                        {/* Heading */}
                        <div className="users-heading-row">
                            <div>
                                <h2 className="users-title">Users Details</h2>
                                <p className="users-subtitle">
                                    {users.length} {users.length === 1 ? "user" : "users"} registered
                                </p>
                            </div>
                        </div>

                        {users.length === 0 ? (
                            <div className="users-empty">
                                <div className="users-empty-badge">0</div>
                                <p className="users-empty-text">No users to display</p>
                                <p className="users-empty-sub">New sign-ups will show up here.</p>
                            </div>
                        ) : (
                            <>
                                {/* Table Card */}
                                <div className="users-card">
                                    <div className="table-responsive">
                                        <Table className="users-table mb-0 align-middle">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>User Type</th>
                                                    <th className="d-none d-md-table-cell">Address</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {users.map((u) => (
                                                    <tr key={u.userId}>
                                                        <td className="users-id">{u.userId}</td>
                                                        <td className="fw-semibold">{u.userName}</td>
                                                        <td className="text-break text-muted">{u.userEmail}</td>
                                                        <td>
                                                            <span className="users-pill">
                                                                {u.userType}
                                                            </span>
                                                        </td>
                                                        <td
                                                            className="d-none d-md-table-cell text-truncate text-muted"
                                                            style={{ maxWidth: "200px" }}
                                                        >
                                                            {u.address ?? "-"}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>

                                {/* Pagination Section */}
                                <div className="users-pagination">
                                    <PaginationComponent
                                        page={page}
                                        setPage={setPage}
                                        size={size}
                                        setSize={setSize}
                                        totalPages={totalPages}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                )}

            </div>

            <style>{`
        .users-page {
            min-height: 100vh;
            background: #F7F8F6;
            display: flex;
            flex-direction: column;
            font-family: 'Inter', sans-serif;
        }

        .users-loading {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
        }

        .users-container {
            max-width: 1180px;
            width: 100%;
            margin: 0 auto;
            padding: 32px 24px;
            flex: 1;
        }

        .users-heading-row {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-bottom: 22px;
        }

        .users-title {
            font-weight: 700;
            font-size: 24px;
            color: #1C2420;
            margin: 0;
        }

        .users-subtitle {
            font-size: 13.5px;
            color: #8B978F;
            margin: 4px 0 0;
        }

        .users-empty {
            text-align: center;
            padding: 72px 20px;
            background: #fff;
            border-radius: 16px;
            border: 1px solid #EDEFEA;
        }

        .users-empty-badge {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background: rgba(224, 123, 57, 0.1);
            color: #e07b39;
            font-weight: 700;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 16px;
        }

        .users-empty-text {
            font-weight: 600;
            font-size: 17px;
            color: #1C2420;
            margin: 0 0 4px;
        }

        .users-empty-sub {
            font-size: 13.5px;
            color: #8B978F;
            margin: 0;
        }

        .users-card {
            background: #fff;
            border-radius: 16px;
            border: 1px solid #EDEFEA;
            box-shadow: 0 1px 2px rgba(16, 24, 20, 0.03);
            overflow: hidden;
        }

        .users-table thead {
            background: rgba(224, 123, 57, 0.06);
        }

        .users-table thead th {
            font-size: 11.5px;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            font-weight: 700;
            color: #B8632C;
            padding: 14px 16px;
            border-bottom: 1px solid #F0E4D8;
            white-space: nowrap;
        }

        .users-table tbody td {
            padding: 14px 16px;
            font-size: 14px;
            color: #333B36;
            border-bottom: 1px solid #F2F3F0;
            vertical-align: middle;
        }

        .users-table tbody tr:last-child td {
            border-bottom: none;
        }

        .users-table tbody tr:hover {
            background: #FBFAF8;
        }

        .users-id {
            font-weight: 600;
            color: #5C6862;
        }

        .users-pill {
            display: inline-block;
            padding: 4px 11px;
            border-radius: 999px;
            font-size: 12px;
            font-weight: 600;
            background: rgba(224, 123, 57, 0.14);
            color: #B8632C;
            text-transform: capitalize;
        }

        .users-pagination {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
        }
    `}</style>
        </Layout>

    );
};

export default UsersDetails;
